/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2024-11-19 18:22:12
 */
import React, { useEffect } from 'react'
import { Button } from 'antd'
import sensors from '../../../../utils/sensors'
import {
  useAppDispatch,
  useAppSelector,
  usePathValue
} from '../../../../app/hooks'
import { setPaymentVisible } from '../../../../actions/main'
import CONFIG from '../../../../constants/config'
import useCheckedPhotoNum from '../../hooks/useCheckedPhotoNum'

const VipAlert = ({ visible }) => {
  const groupID = useAppSelector((state) => state.group.groupId)
  const dispatch = useAppDispatch()
  const isVip = useAppSelector((state) => state.group.isVip)
  const checkedNum = useCheckedPhotoNum()

  const pathValue = usePathValue()
  const isShow = !isVip && checkedNum <= CONFIG.freeDownloadLimit
  const onPay = () =>
    dispatch(setPaymentVisible(true, 'photoFolderDownloadPhoto'))

  useEffect(() => {
    if (isShow && visible) {
      sensors.track('web_show_page_openapp_workgroupvip', {
        groupID: groupID,
        place: pathValue,
        functionType: 'downloadPhoto'
      })
    }
  }, [isShow, visible])

  if (isShow) {
    return (
      <div className="vip-alert">
        <span>批量下载为团队会员专属功能，开通团队会员即享30+权益</span>
        <Button
          type="link"
          size="small"
          style={{ fontWeight: 'bold' }}
          onClick={() => {
            sensors.track('web_click_button_workgroup_go_vip_trigger', {
              place: pathValue,
              functionType: 'downloadPhoto',
              groupID: groupID
            })
            onPay()
          }}
        >
          [立即开通]
        </Button>
      </div>
    )
  }
  return null
}

export default VipAlert
